import React from 'react';
import LegalPage from './LegalPage';

const DataDeletion = () => (
  <LegalPage title="Data Deletion" updated="25 April 2026">
    <p>
      This page explains how to request deletion of your EduManage account and
      the data associated with it. Google Play and the Apple App Store require
      every app to publish a clear, user-accessible deletion flow — this is ours.
    </p>

    <h2>What can be deleted</h2>
    <ul>
      <li>Your user account (name, email, phone, password, role)</li>
      <li>Your push notification tokens</li>
      <li>
        If you are a parent: the student records linked to your email, including
        attendance, marks, homework submissions, health records, diary entries
      </li>
      <li>If you are a school admin: the entire school's workspace, on written request from the school's authorised signatory</li>
    </ul>

    <h2>What we retain after deletion</h2>
    <p>
      Some information is kept for a short period because Indian tax and
      company-law rules require it:
    </p>
    <ul>
      <li>Invoice and billing records for the applicable tax year (up to 7 years per GST rules)</li>
      <li>Server logs that reference your account are rotated out within 30 days</li>
      <li>Database backups containing deleted records are rotated out within 90 days</li>
    </ul>
    <p>
      After these retention windows, the data is permanently and irreversibly
      purged.
    </p>

    <h2>How to request deletion</h2>

    <h3>Option 1 — If your school is the account owner</h3>
    <p>
      Ask your school's admin to remove your account from the admin dashboard.
      This is the fastest option and takes effect immediately.
    </p>

    <h3>Option 2 — Email us directly</h3>
    <p>
      Send an email to <a href="mailto:pramod@rtconnect.in">pramod@rtconnect.in</a> with:
    </p>
    <ul>
      <li><strong>Subject line</strong>: "Data deletion request — EduManage"</li>
      <li>The email address you use to sign in</li>
      <li>The name of your school (or school code, e.g. "DEMO", "KAKATIYA")</li>
      <li>Your role (admin / teacher / parent / student)</li>
      <li>For parents requesting deletion of a child's records: the child's full name and admission number</li>
    </ul>
    <p>
      We verify every request before acting on it. For student records, we
      confirm the request is coming from the parent/guardian on file or from
      the school's admin.
    </p>

    <h2>Response time</h2>
    <ul>
      <li>We acknowledge receipt within <strong>3 business days</strong></li>
      <li>We complete verified deletion requests within <strong>30 days</strong>, usually much sooner</li>
      <li>You'll get a confirmation email once the deletion is complete</li>
    </ul>

    <h2>What happens after deletion</h2>
    <ul>
      <li>You will no longer be able to sign in with the deleted email</li>
      <li>Any push notifications to the deleted device stop immediately</li>
      <li>If you were a parent, your child's records linked to you are removed</li>
      <li>If you re-register later with the same email, it is treated as a brand-new account with no history</li>
    </ul>

    <h2>Questions</h2>
    <p>
      Email <a href="mailto:pramod@rtconnect.in">pramod@rtconnect.in</a> for anything that isn't covered here.
    </p>
  </LegalPage>
);

export default DataDeletion;
